import React from 'react';
import { BiSearch } from 'react-icons/bi';
import { Props } from './types';

import { Container, Input } from './styles';

const InputSearch: React.FC<Props> = ({ setSearchValue, searchValue }) => {
  return (
    <Container>
      <BiSearch size={22} color="#0000008a" />
      <Input
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        placeholder="Digite sua pesquisa"
      />
    </Container>
  );
};

export default InputSearch;
